import {
  getLocalStorageMenuItem,
  ISDARKTHEME,
  SARIconThemeColor,
  setMobileBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileSubTextColor,
  setMobileTextColor,
  setMobileButttonBackColor,
  setLocalStorageMenuItem,
  setMobileHighlightTextColor,
} from "../../../utility";

import no_image from "../../../images/No_Image_Available.jpg";
import {
  useSearchParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import FavortieIcon from "./favoriteIcon";
import { t } from "i18next";
import { Badge, Button } from "react-bootstrap";
import { useState } from "react";
import { AddOutlined, AddShoppingCartSharp, ShoppingCartCheckoutOutlined, ShoppingCartOutlined } from "@mui/icons-material";
import { IconButton, CircularProgress } from "@mui/material";
import axios from "axios";
import { useQueryClient, useMutation, useQuery } from "react-query";
import Toast from "../../../common/toast";
import LoadingTreeDataDialog from "../mobileComponents/LoadingTreeDataDialog";

const onImageError = (e) => {
  e.target.src = no_image;
};

const DishFullRow = ({
  item,
  qrCode,
  in_root,
  qrName,
  sympole,
  handleFavorite,
  favorites,
  suggested,
  scrollPosition,
  not_menu_availability,
  isDesktop,
}) => {
  const [loadingTreeDialog, setLoadingTreeDialog] = useState(false);
  const [params] = useSearchParams();
  const [treeData] = useState(
    getLocalStorageMenuItem("tree_data") || []
  );
  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    success: false,
  });
  const queryClient = useQueryClient();

  const navigate = useNavigate();
  const location = useLocation();

  const handleOpenToast = (message, status) => {
    const toast = { ...toastSettings };
    toast.open = true;
    toast.success = status === undefined ? true : status;
    toast.message = message;
    setToastSettings(toast);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setToastSettings({ open: false, message: "", success: false });
  };

  // Mutation for adding item to cart
  const addToCartMutation = useMutation(
    (itemData) => {
      const token = getLocalStorageMenuItem("gustToken");
      const values = {
        table: params.get("t"),
        item_id: itemData.id,
        modifiers: [],
        price_option: itemData?.has_price_options && itemData?.price_options?.length > 0 ? itemData?.price_options?.[0]?.id || null : itemData?.has_price_option_item && itemData?.price_option_items?.length > 0 ? itemData?.price_option_items?.[0]?.id : null,
        quantity: 1,
        notes: "",
        menu_code: qrCode,
        price: itemData.price,
        token: token,
        prevOptionPrice: 0,
      };

      const itemDataVal = treeData?.items?.find((item) => item.id === Number(values.item_id));
      const selectedOrderType = getLocalStorageMenuItem("orderType");

      if (selectedOrderType === "delivery" && !itemDataVal?.is_delivery_on) {
        return { success_add: false, type: selectedOrderType }
      }

      if (selectedOrderType === "pickup" && !itemDataVal?.is_pickup_on) {
        return { success_add: false, type: selectedOrderType }
      }

      if (selectedOrderType === "dinein" && !itemDataVal?.is_dinein_on) {
        return { success_add: false, type: selectedOrderType }
      }

      return axios.post(
        `${process.env.REACT_APP_API}/basket-items`,
        values,
        {
          headers: {
            localization: getLocalStorageMenuItem("lang"),
          },
        }
      );
    },
    {
      onSuccess: (res) => {
        if (res && res?.hasOwnProperty('success_add') && !res?.success_add) {
          handleOpenToast(t("sorry!, this item isn't available for the order type") + " " + t(`${res?.type}`), false);
        } else {
          queryClient.invalidateQueries(["basket-items-count", getLocalStorageMenuItem("lang")]);
          queryClient.invalidateQueries(["basket-items", getLocalStorageMenuItem("lang")]);

          handleOpenToast(t("Order has been added successfully"), true);
        }
      },
      onError: (error) => {
        console.error("Error adding to cart:", error);
        handleOpenToast(
          error.response?.data?.message || t("Failed to add item to cart"),
          false
        );
      },
    }
  );

  // const openItem = () => {
  //   if (item.sold_out !== 1) {
  //     navigate(
  //       `/${qrName}/${qrCode}/items?item=${item.id}&section=${params.get("section")}&t=${params.get(
  //         "t"
  //       )}&oneItem=${params.get("oneItem")}&selectedLang=${getLocalStorageMenuItem(
  //         "lang"
  //       )}`,
  //       {
  //         replace: true,
  //         state: {
  //           itemData: item,
  //           sympole: sympole,
  //           in_root: in_root,
  //           from: location.pathname + location.search,
  //         },
  //       }
  //     );
  //   }
  // };


  // const openItem = () => {
  //   if (item.sold_out !== 1) {
  //     // Store current scroll position before navigating
  //     const currentScrollPosition = window.scrollY;
  //     sessionStorage.setItem('itemScrollPosition', currentScrollPosition.toString());

  //     navigate(
  //       `/${qrName}/${qrCode}/items?item=${item.id}&section=${params.get("section")}&t=${params.get("t")}...`,
  //       {
  //         replace: true,
  //         state: {
  //           itemData: item,
  //           scrollPosition: currentScrollPosition, // Pass scroll position
  //         },
  //       }
  //     );
  //   }
  // };

  const openItem = () => {
    if (item.sold_out !== 1) {

      const currentScrollPosition = window.scrollY;
      setLocalStorageMenuItem('itemScrollPosition', currentScrollPosition.toString());
      navigate(
        `/${qrName}/${qrCode}/items?item=${item.id}&section=${params.get("section")}&t=${params.get(
          "t"
        )}&oneItem=${params.get("oneItem")}&selectedLang=${getLocalStorageMenuItem(
          "lang"
        )}`,
        {
          replace: true,
          state: {
            itemData: item,
            sympole: sympole,
            in_root: in_root,
            from: location.pathname + location.search,
            scrollPosition: currentScrollPosition,
          },
        }
      );
    }
  };
  const handleAddToCart = (e) => {
    e.stopPropagation();

    if (not_menu_availability) {
      setLoadingTreeDialog(true);
      return;
    }
    if (item.sold_out === 1) {
      handleOpenToast(t("This item is out of stock"), false);
      return;
    }

    if (item?.modifiers && item?.modifiers?.length > 0) {
      openItem();
      return;
    }



    addToCartMutation.mutate(item);
  };

  return (
    <>
      <div
        className={`dishe-full-card col-md-12 mt-3 mx-auto position-relative alignByLang ${isDesktop ? 'gap-2' : ''}`}
        style={{
          height: item.sold_out === 1 ? "200px" : "185px",
          backgroundColor:
            getLocalStorageMenuItem("theme") === "dark" ||
              getLocalStorageMenuItem("theme") === "light" ||
              getLocalStorageMenuItem("theme") === "costomize"
              ? setMobileCardColor()
              : "",
          borderColor:
            getLocalStorageMenuItem("theme") === "dark" ||
              getLocalStorageMenuItem("theme") === "light" ||
              getLocalStorageMenuItem("theme") === "costomize"
              ? setMobileCardBorderColor()
              : setMobileCardBorderColor(),
          borderWidth: 1,
          padding: "12px",
          position: "relative",
          // width: isDesktop ? '30%' : '100%',
        }}
        onClick={openItem}
      >
        <div className="dishe-full-card-data">
          <h2
            className="item-name mb-0 cursor head-font"
            style={{
              color: setMobileTextColor(),
            }}
          >
            {item.name}
          </h2>
          <h3
            className="item-description mt-1 sub-font"
            style={{
              color: setMobileSubTextColor(),
              maxLines: 1,
            }}
          >
            {item.description}
          </h3>
          <div
            style={{
              padding: "3px",
            }}
            className=""
          >
            <Badge
              style={{
                borderRadius: "8px",
              }}
              className={`${item.sold_out === 1 ? "" : "d-none"
                } outofinstock-badge-dish-style p-2 font-size-12 sub-font m-1`}
            >
              {t("Out of stock")}
            </Badge>
          </div>

          {/* Price Section - Repositioned to avoid overlap */}
          <div
            className={`position-absolute`}
            style={
              getLocalStorageMenuItem("lang") === "ar" ||
                getLocalStorageMenuItem("lang") === "fa"
                ? {
                  bottom: "50px", // Moved up to make space for button
                  left: "12px",
                }
                : {
                  bottom: "50px", // Moved up to make space for button
                  right: "12px",
                }
            }
          >
            {item.has_price_options ? (
              <strong
                className="head-font"
                style={{
                  color:
                    getLocalStorageMenuItem("theme") === "costomize"
                      ? setMobileTextColor()
                      : "#6ba5f2 ",
                }}
              >
                {item.lowest_price_option
                  ? t("STARTS AT") + " " + item.lowest_price_option
                  : item.price || 0}{" "}
                {sympole ? sympole === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : sympole : ""}
              </strong>
            ) : (
              <strong
                className="head-font"
                style={{
                  color:
                    getLocalStorageMenuItem("theme") === "costomize"
                      ? setMobileTextColor()
                      : "#6ba5f2 ",
                  fontSize: 20,
                }}
              >
                {item?.old_price > 0 && (
                  <span
                    style={{
                      textDecoration: "line-through",
                      color: "red",
                    }}
                  >
                    {item.old_price || ""}
                  </span>
                )}{" "}
                {item.price} {sympole ? sympole === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : sympole : ""}
              </strong>
            )}
          </div>
        </div>

        {item.sold_out !== 1 && (
          <div
            className="position-absolute d-flex justify-content-end alignByLang"
            style={{
              bottom: "12px",
              right: getLocalStorageMenuItem("lang") === "ar" ||
                getLocalStorageMenuItem("lang") === "fa"
                ? "auto" : "12px",
              left: getLocalStorageMenuItem("lang") === "ar" ||
                getLocalStorageMenuItem("lang") === "fa"
                ? "12px" : "auto",
              // zIndex: 10,
              width: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleAddToCart}
              disabled={addToCartMutation.isLoading}
              className="btn d-flex align-items-center justify-content-center alignByLang"
              style={{
                backgroundColor: setMobileButttonBackColor() || "#007bff",
                color: "#ffffff",
                border: "none",
                borderRadius: "5px",
                padding: "1px 8px",
                fontSize: "12px",
                fontWeight: "600",
                minWidth: "50px",
                height: "36px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                transition: "all 0.2s ease-in-out",
                cursor: addToCartMutation.isLoading ? "not-allowed" : "pointer",
                opacity: addToCartMutation.isLoading ? 0.7 : 1,
              }}
              onMouseOver={(e) => {
                if (!addToCartMutation.isLoading) {
                  e.target.style.transform = "translateY(-1px)";
                  e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
                }
              }}
              onMouseOut={(e) => {
                if (!addToCartMutation.isLoading) {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                }
              }}
            >
              {addToCartMutation.isLoading ? (
                <div className="alignByLang">
                  <CircularProgress size={16} color="inherit" style={{ margin: "4px" }} />
                  <span>{t("Adding...")}</span>
                </div>
              ) : (
                <div className="alignByLang">
                  <AddShoppingCartSharp fontSize="25" color={setMobileHighlightTextColor() || setMobileTextColor()} style={{ fontSize: "25px", margin: "4px",color: setMobileHighlightTextColor() || setMobileTextColor()}} />
                </div>
              )}
            </button>
          </div>
        )}

        <div>
          <img
            className="mainImage cursor"
            src={item.image ? item.image : no_image}
            onError={onImageError}
            style={{ position: "relative", height: "80%" }}
          />
          <FavortieIcon
            item={item}
            handleFavorite={handleFavorite}
            favorites={favorites}
            suggested={suggested}
          />

          <div style={{
            padding: "6px",
          }}>
            {item?.warnings?.map((element) => (
              <img
                key={element.id}
                style={{
                  width: "24px",
                  height: "24px",
                  marginInline: "8px",
                }}
                src={
                  ISDARKTHEME(
                    getLocalStorageMenuItem("theme") ||
                    treeData?.details?.mobile_settings?.theme,
                    setMobileBackColor() ||
                    treeData?.details?.mobile_settings?.colorProps?.back
                  )
                    ? element?.icon_dark || element.icon
                    : element?.icon_light || element.icon
                }
                onError={onImageError}
                alt="icon"
                className="mx-1"
              />
            ))}
          </div>
        </div>
      </div>

      <Toast
        open={toastSettings.open}
        message={toastSettings.message}
        resetToast={handleCloseToast}
        success={toastSettings.success}
      />

      <LoadingTreeDataDialog
        openTreeDialogFlag={loadingTreeDialog}
        onClose={() => setLoadingTreeDialog(false)}
        tableName={qrName}
        tableQr={qrCode}
        from_home={false}
      />
    </>
  );
};

export default DishFullRow;
